import ReviewerSvg from 'assets/icons/Reviewer.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(ReviewerSvg, { displayName: 'ReviewerOutlined' });
